class GroupBlockAccordion {
  /**
   * @param {Element} root
   */
  constructor(root) {
    this.root = root;
    /** @type {HTMLElement|null} */
    this.wrapper = null;
    /** @type {HTMLElement|null} */
    this.track = null;
    /** @type {HTMLButtonElement|null} */
    this.nextBtn = null;
    /** @type {HTMLButtonElement|null} */
    this.prevBtn = null;
    /** @type {number} */
    this.totalSlides = 0;
    /** @type {number} */
    this.currentIndex = 0;
    /** @type {boolean} */
    this.isReversing = false;

    /** @type {HTMLElement|null} */
    const wrapper = root.querySelector('.section-content-wrapper');
    if (!wrapper) return;
    this.wrapper = wrapper;

    const children = Array.from(wrapper.children);
    if (children.length <= 1) return;

    this.totalSlides = children.length;

    // Create track and wrap children
    const track = document.createElement('div');
    track.className = 'group-slide-track';
    children.forEach((child) => track.appendChild(child));
    wrapper.appendChild(track);
    this.track = track;

    // Create buttons
    const nextBtn = this.createButton('next');
    const prevBtn = this.createButton('prev');
    wrapper.appendChild(nextBtn);
    this.nextBtn = nextBtn;
    this.prevBtn = prevBtn;

    // Move buttons outside wrapper so overflow:hidden doesn't clip them
    // Place button as a sibling after the wrapper within the section
    const sectionContent = wrapper.closest('.custom-section-content');
    if (sectionContent) {
      sectionContent.appendChild(nextBtn);
    }

    this.updateButtons();
  }

  /**
   * @param {'next'|'prev'} type
   * @returns {HTMLButtonElement}
   */
  createButton(type) {
    const btn = document.createElement('button');
    const isNext = type === 'next';
    btn.className = isNext ? 'group-slide-next' : 'group-slide-prev';
    btn.setAttribute('aria-label', isNext ? 'Next slide' : 'Previous slide');
    btn.innerHTML = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"></path></svg>';
    btn.addEventListener('click', () => {
      if (isNext) this.slideNext();
      else this.slidePrev();
    });
    btn.style.display = 'none';
    return btn;
  }

  slideNext() {
    if (this.currentIndex >= this.totalSlides - 1) return;
    this.isReversing = false;
    this.currentIndex++;
    this.slideTo(this.currentIndex);
    this.updateButtons();
    this.revealContent();
  }

  slidePrev() {
    if (this.currentIndex <= 0) return;
    this.isReversing = true;
    this.currentIndex--;
    this.slideTo(this.currentIndex);
    this.updateButtons();
    this.revealContent();
  }

  revealContent() {
    if (this.track && !this.track.classList.contains('revealed')) {
      this.track.classList.add('revealed');
    }
  }

  /**
   * @param {number} index
   */
  slideTo(index) {
    if (!this.track) return;
    this.track.style.transform = `translateX(-${index * 100}%)`;
  }

  updateButtons() {
    if (!this.nextBtn || !this.prevBtn || !this.wrapper) return;

    const isFirst = this.currentIndex === 0;
    const isLast = this.currentIndex === this.totalSlides - 1;

    if (this.totalSlides <= 1) {
      this.nextBtn.style.display = 'none';
      this.prevBtn.style.display = 'none';
      return;
    }

    if (isFirst) {
      this.nextBtn.style.display = 'flex';
      this.prevBtn.style.display = 'none';
      this.placeButtonAfterWrapper(this.nextBtn);
      this.revealContent();
    } else if (isLast) {
      this.nextBtn.style.display = 'none';
      this.prevBtn.style.display = 'flex';
      this.placeButtonAfterWrapper(this.prevBtn);
      this.revealContent();
    } else if (this.isReversing) {
      // Middle slide, coming from right → show left arrow
      this.nextBtn.style.display = 'none';
      this.prevBtn.style.display = 'flex';
      this.placeButtonAfterWrapper(this.prevBtn);
    } else {
      // Middle slide, coming from left → show right arrow
      this.nextBtn.style.display = 'flex';
      this.prevBtn.style.display = 'none';
      this.placeButtonAfterWrapper(this.nextBtn);
    }
  }

  /**
   * @param {HTMLElement} btn
   */
  placeButtonAfterWrapper(btn) {
    if (!this.wrapper) return;
    const sectionContent = this.wrapper.closest('.custom-section-content');
    if (sectionContent) {
      sectionContent.appendChild(btn);
    }
  }

  destroy() {
    const wrapper = this.wrapper;
    const track = this.track;
    if (track && wrapper) {
      const children = Array.from(track.children);
      children.forEach((child) => wrapper.appendChild(child));
      track.remove();
      this.track = null;
    }
    if (this.nextBtn) { this.nextBtn.remove(); this.nextBtn = null; }
    if (this.prevBtn) { this.prevBtn.remove(); this.prevBtn = null; }
  }
}

const MOBILE_BREAKPOINT = 749;

function isMobile() {
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
}

function initGroupBlockAccordions() {
  const sections = document.querySelectorAll('[id*="section_GRkp3R"]');
  sections.forEach((section) => {
    /** @type {GroupBlockAccordion|undefined} */
    // @ts-ignore
    const existing = section._groupAccordion;

    if (isMobile()) {
      // Mobile: initialize accordion
      if (existing) existing.destroy();
      const accordion = new GroupBlockAccordion(section);
      // @ts-ignore
      section._groupAccordion = accordion;
    } else {
      // Desktop: destroy accordion if exists, restore original DOM
      if (existing) {
        existing.destroy();
        // @ts-ignore
        section._groupAccordion = undefined;
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initGroupBlockAccordions);
document.addEventListener('shopify:section:load', (/** @type {CustomEvent} */ e) => {
  if (e.detail && e.detail.sectionId && e.detail.sectionId.includes('GRkp3R')) {
    initGroupBlockAccordions();
  }
});

// Handle window resize - switch between mobile/desktop
/** @type {ReturnType<typeof setTimeout>|undefined} */
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initGroupBlockAccordions, 150);
});
